// extracted by mini-css-extract-plugin
export default {"backdrop":"style_backdrop__8dt81","modal":"style_modal__4u1-G","slide-down":"style_slide-down__Dk1yC","content":"style_content__4-bw8","button":"style_button__L25o1"};